import React from 'react'
import './index.scss'

const ContactData = () => (
  <div className="contact-data">
    <div className="contact-data__container">
      <div className="contact-data__headline headline">
        <h2>Kontaktdaten</h2>
      </div>
      <div className="contact-data__content">
        <p>
          <b>holzweg GmbH</b>{' '}
        </p>
        <p>Adamgasse 11, 3. Stock </p>
        <p>6020 Innsbruck</p>
        <p>
          Email: <a href="mailto:office@holzweg.com">office@holzweg.com</a>
        </p>
        <p>Firmenbuchnummer: FN423141t</p>
        <p>UID: ATU69192759</p>
        <p>Steuernummer: 81/3258928</p>
      </div>
    </div>
  </div>
)

export default ContactData
